<template>
    <div class="grade_item-container">
        <h2 class="grade_item-name">Результаты прохождения</h2>
        <v-data-table
            class="elevation-1 grade_rating"
            :headers="headers"
            :items="rows"
            :server-items-length="pagesCount"
            :items-per-page="getPageSize"
            :page="params.currentPage"
            :expanded.sync="expanded"
            :loading="loading || loadingTable"
            loading-text="Данные загружаются..."
            hide-default-footer
        >
            <template v-slot:item="row">
                <tr class="rating-row">
                    <td v-if="full" class="rating-cell">
                        {{ row.item.userFio }}
                    </td>
                    <td v-if="full" class="rating-cell">
                        {{ row.item.studyCourseName }}
                    </td>
                    <td v-if="full" class="rating-cell">
                        {{ row.item.studyGroupName }}
                    </td>
                    <td v-if="!full" class="rating-cell">
                        {{ row.item.passTypeName }}
                    </td>
                    <td class="rating-cell">
                        {{ getTestTypeName(row.item.testType) }}
                    </td>
                    <td class="rating-cell">
                        {{ row.item.subjectName }}
                    </td>
                    <td class="rating-cell">
                        {{ row.item.topicName }}
                    </td>
                    <td class="rating-cell">
                        {{ row.item.testName }}
                    </td>
                    <td class="rating-cell text-center">
                        {{ `${row.item.results && row.item.results.length > 0 ? row.item.results[0].score + (row.item.testType === 0 ? ' %' : ' баллов') : ''}` }}
                    </td>
                    <td class="rating-cell text-center">
                        <a href="#" @click.prevent="toggleExpand(row.item)">{{ `${row.item.results ? row.item.results.length : ''}` }}</a>
                    </td>
                </tr>
            </template>
            <template v-slot:expanded-item="{ item }">
                <tr v-for="(result, index) in item.results" :key="result.id" class="rating-row-history" :class="{ 'rating-row-border':  index === item.results.length - 1}">
                    <td :colspan="full ? 8 : 6" class="rating-cell-flex">
                        <div class="cell-container">
                            <div class="cell-flex" style="width: 240px;">
                                <span>Дата прохождения</span>
                                <span>{{ `${result.passDateShort}` }}</span>
                            </div>
                            <div class="cell-flex" style="width: 185px;">
                                <span>Результат</span>
                                <v-progress-circular
                                    :value="result.score"
                                    :color="getScoreColor(result.score)"
                                    :size="33"
                                    :width="4"
                                    class="mr-2"
                                ></v-progress-circular>
                                <span>{{ `${result.score} ${item.testType === 0 ? ' %' : ' б'}` }}</span>
                            </div>
                            <v-btn v-if="item.testType === 0"
                                @click.stop="learningResultDialog.open(item.userId, item.testId, result.id)"
                                :loading="learningResultDialog.loading && learningResultDialog.id === result.id"
                                :disabled="learningResultDialog.loading && learningResultDialog.id !== result.id"
                                class="btn cell-btn"
                            >
                                Просмотр результатов
                            </v-btn>
                            <v-btn v-else-if="item.testType === 1"
                                @click.stop="diagnosticsResultDialog.open(item.userId, item.testId, result.id)"
                                :loading="diagnosticsResultDialog.loading && diagnosticsResultDialog.id === result.id"
                                :disabled="diagnosticsResultDialog.loading && diagnosticsResultDialog.id !== result.id"
                                class="btn cell-btn"
                            >
                                Просмотр результатов
                            </v-btn>
                        </div>
                    </td>
                </tr>
            </template>
            <template v-slot:footer>
                <div class="data-footer">
                    <div class="pagination" v-if="getPageSize != allItemsSize">
                        <span>Cтраница:</span>
                        <div @click.prevent="prevPage" class="pagination_prev" :class="{ 'disabled': params.currentPage === 0 }">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path id="shape" fill-rule="evenodd" clip-rule="evenodd" d="M0.269108 8.64968L6.70064 15.0812L8 13.7818L2.21815 8L8 2.21815L6.70064 0.918787L0.269108 7.35031C-0.0897023 7.70912 -0.0897023 8.29087 0.269108 8.64968Z" fill="#878A91"/>
                            </svg>
                        </div>
                        <div class="pagination_number">
                            {{ params.currentPage + 1 }}
                        </div>
                        <div v-if="getPageSize" @click.prevent="nextPage" class="pagination_next" :class="{ 'disabled': params.currentPage === (pagesCount - 1) }">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73089 8.64965L1.29936 15.0812L-5.6797e-08 13.7818L5.78185 7.99997L-5.62262e-07 2.21812L1.29936 0.918756L7.73089 7.35028C8.0897 7.70909 8.0897 8.29084 7.73089 8.64965Z" fill="#878A91"/>
                            </svg>
                        </div>
                    </div>
                    <div class="items-per-page">
                        <span>Выводить:</span>
                        <div class="items-per-page_drop">
                            <v-menu>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="white"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <span>{{ getPageSize != allItemsSize ? getPageSize : 'Все' }}</span>
                                        <div class="drop-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41079 14.5118L3.57745 8.67851L4.75596 7.5L10 12.7441L15.2441 7.5L16.4226 8.67851L10.5893 14.5118C10.2639 14.8373 9.73622 14.8373 9.41079 14.5118Z" fill="black"/>
                                            </svg>
                                        </div>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        v-for="(item, index) in pageSizes"
                                        :key="index"
                                        @change="updatePageSize(item.size)"
                                    >
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </div>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { helpers } from '@/store/tests';

const AllItemsSize = 10000;

export default {
    name: 'ResultsTableDesktop',
    props: {
        full: Boolean,
        loading: Boolean,
        learningResultDialog: Object,
        diagnosticsResultDialog: Object
    },
    data: () => ({
        fromArchive: false,
        params: {
            filters: [],
            currentPage: 0,
            columns: []
        },
        headers: [],
        rows: [],
        expanded: [],
        pagesCount: 0,
        allItemsSize: AllItemsSize,
        pageSizes: [
            { name: '5', size: 5 },
            { name: '10', size: 10 },
            { name: '15', size: 15 },
            { name: 'Все', size: AllItemsSize }
        ],
        loadingTable: false
    }),
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            getPageSize: 'tests/getPageSize'
        })
    },
    methods: {
        ...mapActions({
           changePageSize: 'tests/changePageSize'
        }),
        update(data, filters, fromArchive) {
            this.fromArchive = fromArchive;
            this.rows = data.data[0].rows;
            this.pagesCount = Math.ceil(data.totalRecords / data.pageSize);

            this.params.currentPage = 0;
            this.params.filters = filters;
        },
        loadResults() {
            this.loadingTable = true;

            this.$http.post(`${this.apiUrl}TestTask/GetResultsReport?rowsOnly=true&fromArchive=${this.fromArchive}`, {...this.params, pagesize: this.getPageSize })
                .then((result) => {
                    this.rows = result.data.data[0].rows;
                    this.pagesCount = this.getPageSize ? Math.ceil(result.data.totalRecords / this.getPageSize) : 1;
                    this.loadingTable = false;
            });
        },
        getTestTypeName(type) {
            return helpers.testTypes[type];
        },
        getScoreColor(score) {
            return helpers.getScoreColor(score);
        },
        prevPage() {
            if (this.params.currentPage > 0) {
                this.params.currentPage--;
                this.loadResults();
            }
        },
        nextPage() {
            if (this.params.currentPage < (this.pagesCount - 1)) {
                this.params.currentPage++;
                this.loadResults();
            }
        },
        updatePageSize(size) {
            this.params.currentPage = 0;
            this.changePageSize(size);
            this.loadResults();
        },
        toggleExpand(row) {
            let index = this.expanded.findIndex(x => x.id === row.id);

            if (index === -1) {
                this.expanded.push(row);
            } else {
                this.expanded.splice(index, 1);
            }
        }
    },
    created() {
        console.log();
        this.headers = this.full ?
        [
            { text: 'ФИО', width: '15%', sortable: false },
            { text: 'Курс', width: '5%', sortable: false },
            { text: 'Группа', width: '10%', sortable: false },
            { text: 'Тип теста', width: '10%', sortable: false },
            { text: 'Дисциплина', width: '15%', sortable: false },
            { text: 'Тема', width: '15%', sortable: false },
            { text: 'Наименование теста', width: '10%', sortable: false },
            { text: 'Последний результат', width: '10%', sortable: false },
            { text: 'Количество прохождений', width: '10%', sortable: false }
        ] :
        [
            { text: 'Вид теста', width: '12%', sortable: false },
            { text: 'Тип теста', width: '12%', sortable: false },
            { text: 'Дисциплина', width: '17%', sortable: false },
            { text: 'Тема', width: '18%', sortable: false },
            { text: 'Наименование теста', width: '17%', sortable: false },
            { text: 'Последний результат', width: '12%', sortable: false },
            { text: 'Количество прохождений', width: '12%', sortable: false }
        ]
    }
}
</script>

<style scoped lang="scss">
@import './desktopView.scss';
</style>

<style scoped>
.theme--light.v-data-table >>> .v-data-table__wrapper > table > thead > tr:last-child > th  {
    background: white;
}

.theme--light.v-data-table >>> .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table >>> .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
    border-bottom: 0px solid #CACDD3;
}

.v-data-table >>> .v-data-table__wrapper > table tr:not(:last-child) {
    border-bottom: none;
}

.v-data-table >>> .v-data-table__wrapper > table tr.rating-row-border {
    border-bottom: 1px solid #CACDD3;
}

.theme--light.v-data-table >>> .v-data-table__wrapper > table > thead > tr > th {
    width: 264px;
    color: #AAAEB7;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.v-data-table >>> .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table >>> .v-data-table__wrapper > table > tfoot > tr > td {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.theme--light.v-data-table >>> .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table >>> .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
    border-bottom: none;
}

.data-footer .items-per-page .items-per-page_drop >>> .v-btn__content {
    margin-right: 0;
}
</style>
